function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.707 19.879l-4.37-4.37A9.932 9.932 0 0020 10c0-5.514-4.486-10-10-10S0 4.486 0 10s4.486 10 10 10a9.932 9.932 0 005.509-1.663l4.369 4.37a.999.999 0 001.414 0l1.414-1.414a.999.999 0 00.001-1.414zM2 10c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8z",
  fill: "#41BCA3"
});

function SvgMagnify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMjIuNzA3IDE5Ljg3OWwtNC4zNy00LjM3QTkuOTMyIDkuOTMyIDAgMDAyMCAxMGMwLTUuNTE0LTQuNDg2LTEwLTEwLTEwUzAgNC40ODYgMCAxMHM0LjQ4NiAxMCAxMCAxMGE5LjkzMiA5LjkzMiAwIDAwNS41MDktMS42NjNsNC4zNjkgNC4zN2EuOTk5Ljk5OSAwIDAwMS40MTQgMGwxLjQxNC0xLjQxNGEuOTk5Ljk5OSAwIDAwLjAwMS0xLjQxNHpNMiAxMGMwLTQuNDExIDMuNTg5LTggOC04czggMy41ODkgOCA4LTMuNTg5IDgtOCA4LTgtMy41ODktOC04eiIgZmlsbD0iIzQxQkNBMyIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPgo=";
export { SvgMagnify as ReactComponent };